import { ButtonProps, DropDownProps, Dropdown } from 'antd';
import { MenuItemType } from 'antd/es/menu/hooks/useItems';
import { ReactElement, cloneElement } from 'react';

const DropdownButton = ({
  menu,
  children,
  disabled,
  ...props
}: DropDownProps & {
  menu: DropDownProps['menu'];
  children: ReactElement;
  disabled?: boolean;
}) => {
  const item = menu?.items?.[0] as MenuItemType;

  return menu?.items?.length > 1 ? (
    <Dropdown
      className="mt-1 mr-2"
      placement="bottomLeft"
      menu={menu}
      disabled={disabled}
      {...props}
    >
      {children}
    </Dropdown>
  ) : (
    cloneElement(children as ReactElement<ButtonProps>, {
      disabled: item?.disabled,
      // @ts-ignore
      onClick: item?.onClick,
      ...props,
    })
  );
};

export default DropdownButton;
